var exports = {
  "kL": "x93eb46d8--be0e5f--container",
  "Kk": "x93eb46d8--be0e5f--icon",
  "jp": "x93eb46d8--be0e5f--text-with-icon",
};

module.exports = exports;
